import { UserType } from '../../auth/api/types';

export type Message = {
  id: number;
  created: string;
  modified: string;
  is_removed: boolean;
  sender: UserType;
  text: string;
  is_me: boolean;
  read: boolean;
};

export type Dialog = {
  created: string;
  modified: string;
  id: number;
  is_blocked: boolean;
  is_removed: boolean;
  recipient: UserType;
  last_message: Message | null;
  unread_messages: number;
  user1: number;
  user2: number;
};

export type ChatConnection = {
  isConnected: boolean;
  conversation: null | Dialog;
  messages: Message[];
  conversations: Dialog[];
  isTyping: boolean;
  nextPage: number | null;
  totalUnread: number;
};

export enum ChatMessageTypes {
  GetDialogs = 'get_dialogs',
  GetMessagesFromDialog = 'get_messages_from_dialog',
  StartChat = 'start_chat',
  TextMessage = 'text_message',
  IsTyping = 'is_typing',
  TypingStopped = 'typing_stopped',
  WentOnline = 'went_online',
  WentOffline = 'went_offline',
  MessageRead = 'msg_read',
  NewUnreadCount = 'new_unread',
  TotalUnreadCount = 'total_unread',
  BookDetailsReady = 'book_details_ready'
}
